import type { ProductItemThemeSettings } from '@providers/ThemeProvider/types';

import type { ProductTitleProps } from '@/features/filter-product-list/product-list/product-item/ProductTitle';

export type ProductTitlePropsMapSettings = Pick<
  ProductTitleProps,
  'color' | 'fontSize' | 'textAlign' | 'fontStyle' | 'fontFamily' | 'fontWeight' | 'textTransform'
>;

export const useConnectProductTitle = (settings: ProductItemThemeSettings) => {
  const productTitleSettings = settings.productInfo?.elements?.title;

  return {
    props: productTitleSettings || {},
  };
};
